export default "__VITE_ASSET__c13df494__"